import React, { useCallback, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useAuth } from 'hooks';
import { LogoutActions } from 'store/ducks/auth';
import { ConfirmationDialog, ConfirmationDialogRef } from 'components/Shared';
import * as S from './styles';
import { AuthBar } from 'components/ui/AuthBar';

const TopPanel: React.FC = () => {
  const dialogRef = useRef<ConfirmationDialogRef>(null);
  const { profile } = useAuth();

  const dispatch = useDispatch();

  const handleLogout = useCallback(async (): Promise<void> => {
    const confirmed = await dialogRef.current?.openDialog({
      title: 'Deseja sair?',
    });
    if (confirmed) {
      dispatch(LogoutActions.request());
    }
  }, [dispatch]);

  const Domain = useCallback((): JSX.Element => {
    switch (profile?.type) {
      case 'admin':
        return (
          <div className="flex gap-2 text-sm font-GilroySemibold items-center">
            <S.AdminIcon /> Administrador
          </div>
        );
      case 'companyMember':
        return (
          <div className="flex gap-2 text-sm font-GilroySemibold items-center">
            <S.CompanyIcon /> {profile?.company?.tradeName}
          </div>
        );
      case 'carrierMember':
        return (
          <div className="flex gap-2 text-sm font-GilroySemibold items-center">
            <S.CompanyIcon /> {profile?.carrier?.tradeName}
          </div>
        );
      case 'warehouseMember':
        return (
          <div className="flex gap-2 text-sm font-GilroySemibold items-center">
            <S.WarehouseIcon /> {profile?.warehouse?.tradeName}
          </div>
        );
      default:
        return <></>;
    }
  }, [profile]);

  if (!profile) return null;

  return (
    <header className="mb-4">
      <ConfirmationDialog ref={dialogRef} />

      <AuthBar
        user={{
          name: profile.name,
          avatar: '',
          options: [
            {
              label: 'Sair',
              action: handleLogout,
            },
          ],
        }}
      >
        <Domain />
      </AuthBar>
    </header>
  );
};

export default TopPanel;
